import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { insurerFeatureKey, insurerReducer } from './state/insurer.reducer';
import { InsurerEffects } from './state/insurer.effects';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(insurerFeatureKey, insurerReducer), 
    EffectsModule.forFeature([InsurerEffects])
  ]
})
export class InsurerModule { }
